import type {AlertTitleProps} from '@chakra-ui/react';
import {AlertTitle as BaseAlertTitle} from '@chakra-ui/react';
import {forwardRef} from 'react';

import {useStyles} from './context';

type Props = AlertTitleProps;

export const AlertTitle = forwardRef((props: Props, ref) => {
  const {title} = useStyles();
  return <BaseAlertTitle {...props} __css={title} ref={ref} />;
});
